import { ApiUser, LoginUserRequest } from "../types/users";
import { AbstractBaseApi, ApiMethod, SupportedContentType } from "./AbstractBaseApi";

export class UsersApi extends AbstractBaseApi {
  private static USERS_ENDPOINT = "/users";

  public async getCurrentUser(): Promise<ApiUser> {
    return this.makeApiRequest<SupportedContentType.Json, ApiUser>(
      ApiMethod.Get,
      `${UsersApi.USERS_ENDPOINT}/me`,
      true,
      SupportedContentType.Json,
      undefined,
      undefined,
      undefined,
      SupportedContentType.Json,
    );
  }

  public async login(username: string, password: string): Promise<ApiUser> {
    const request: LoginUserRequest = {
      authentication_method: "password",
      password,
      username,
    };
    return this.makeApiRequest<SupportedContentType.Json, ApiUser>(
      ApiMethod.Post,
      `${UsersApi.USERS_ENDPOINT}/login`,
      false,
      SupportedContentType.Json,
      undefined,
      undefined,
      JSON.stringify(request),
      SupportedContentType.Json,
    );
  }
}
